export const VISIT_CHANNEL_FILTERS = [
  { id: '', label: 'All channels' },
  { id: 'paid_search', label: 'Paid search' },
  { id: 'paid_social', label: 'Paid social' },
  { id: 'other', label: 'Other' },
];

export const VISIT_OUTCOME_FILTERS = [
  { id: '', label: 'All outcomes' },
  { id: 'converted', label: 'Converted / signup' },
  { id: 'signed_in', label: 'Signed in' },
  { id: 'guest', label: 'Guest' },
];

const CHANNEL_LABELS = {
  paid_search: 'Paid search',
  paid_social: 'Paid social',
  other: 'Other',
};

const CONVERTED_EVENTS = new Set([
  'checkout_completed',
  'free_signup_completed',
  'signup_completed',
  'subscription_started',
]);

function humanize(value) {
  if (value == null || value === '') return '';
  return String(value)
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/^\w/, (char) => char.toUpperCase());
}

function channelText(channel) {
  if (!channel) return '';
  return CHANNEL_LABELS[channel] || humanize(channel);
}

function visitText(session) {
  const hops = session?.hops || [];
  const interactions = session?.interactions || [];
  const channel = session?.channel || '';
  const parts = [
    session?.email,
    session?.displayName,
    channel,
    channelText(channel),
    ...hops.map((hop) => (typeof hop === 'string' ? hop : hop?.path)),
    ...interactions.flatMap((row) => [row?.path, row?.eventName, humanize(row?.eventName)]),
  ];
  return parts.filter(Boolean).join(' ').toLowerCase();
}

export function visitIsConverted(session) {
  const hops = session?.hops || [];
  if (hops.some((hop) => (typeof hop === 'string' ? hop : hop?.path) === '/signup/success')) {
    return true;
  }
  return (session?.interactions || []).some((row) => CONVERTED_EVENTS.has(row?.eventName));
}

export function visitIsSignedIn(session) {
  return Boolean(typeof session?.email === 'string' && session.email.includes('@'));
}

function channelMatches(session, channel) {
  if (!channel) return true;
  const value = session?.channel || 'other';
  return value === channel;
}

function outcomeMatches(session, outcome) {
  if (!outcome) return true;
  if (outcome === 'converted') return visitIsConverted(session);
  if (outcome === 'signed_in') return visitIsSignedIn(session);
  if (outcome === 'guest') return !visitIsSignedIn(session);
  return true;
}

export function filterVisitSessions(rows, { query = '', channel = '', outcome = '' } = {}) {
  const needle = String(query || '').trim().toLowerCase();
  return (rows || []).filter((session) => {
    if (!channelMatches(session, channel)) return false;
    if (!outcomeMatches(session, outcome)) return false;
    if (needle && !visitText(session).includes(needle)) return false;
    return true;
  });
}
